import React from 'react';
import _ from 'lodash';
import { useRecoilValue } from 'recoil';
import { useTranslation } from 'react-i18next';
import {
  faCog,
  faUniversity,
  faUser,
  faUsers,
  faHome,
  faSignOut,
  faFileAlt,
  faUpload,
  faHistory,
  faBus,
  faReceipt,
  faDatabase,
  faTasks
} from '@fortawesome/free-solid-svg-icons';
import { userAtom, userPrivilagesAtom } from '../../../atoms/Atoms';
import MainPage from '../../shared-components/main-page/MainPage';
import { H1 } from '../../shared-components/typography/Title';
import HomeCard from './shared-components/HomeCard';
import envConfig from '../../../envConfig';
import analyticsNav from '../../../analytics/analyticsNav';

function Home() {
  const user = useRecoilValue(userAtom);
  const { t } = useTranslation();
  const userPrivilages = useRecoilValue(userPrivilagesAtom);

  return (
    <MainPage>
      <H1 className="mt-4 mb-4" text={t('home_intro')} />
      <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {userPrivilages?.hasGlobalPrivilages && (
          <HomeCard
            icon={faCog}
            title={t('server_config')}
            description={t('server_config_desc')}
            route="/serverconfig"
          />
        )}
        {userPrivilages?.hasDataWarehouseHealthPrivilages && (
          <HomeCard
            icon={faDatabase}
            title={t('data_warehouse')}
            description={t('data_warehouse_desc')}
            route="/datawarehouse"
          />
        )}
        {userPrivilages?.hasAdminPrivilages && (
          <HomeCard
            icon={faUniversity}
            title={t('corporations')}
            description={t('corporations_desc')}
            route="/corporations"
          />
        )}
        {userPrivilages?.hasCustomerSupportPrivilages && (
          <HomeCard
            icon={faUsers}
            title={t('users')}
            description={t('users_desc')}
            route="/users"
          />
        )}
        {/* <HomeCard
          icon={faDatabase}
          title={t('data_comparisons')}
          description={t('data_comparisons_desc')}
          route="/comparisons"
        />
        <HomeCard
          icon={faTasks}
          title={t('category_comparison')}
          description={t('category_comparison_desc')}
          route="/categorycomparison"
        />
        <HomeCard
          icon={faTasks}
          title={t('tax_comparison')}
          description={t('tax_comparison_desc')}
          route="/taxcomparison"
        /> */}
        <HomeCard
          icon={faTasks}
          title={t('daily_movement')}
          description={t('sales_merma_summary_desc')}
          route="/summary/salesshirkage"
        />
        <HomeCard
          icon={faTasks}
          title={t('sales_summary_window')}
          description={t('sales_daily_summary_window_desc')}
          route="/summary/sales/daily"
        />
        {/* <HomeCard
          icon={faTasks}
          title={t('clover_merma_summary')}
          description={t('clover_merma_summary_desc')}
          route="/summary/salesshirkage/clover"
        /> */}
      </div>

      {/* The analytics pages, from the same list the sidebar renders. */}
      {userPrivilages?.hasAnalyticsPrivilages && (
        <>
          <div className="mt-8 mb-3 border-t border-line pt-5 text-xs font-semibold uppercase tracking-wide text-muted">
            {t('analytics_section')}
          </div>
          <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {analyticsNav.map((item) => (
              <HomeCard
                key={item.to}
                icon={item.icon}
                title={t(item.label)}
                description={t(item.description)}
                route={item.to}
              />
            ))}
          </div>
        </>
      )}
    </MainPage>
  );
}

export default Home;
